export const isPolkadot = typeof window !== 'undefined' && window.location.host.includes('polkadot');
